import React from "react";
import { Button, OverlayTrigger, Popover, Table } from "react-bootstrap";

export const LeavePopOver = ({ placement, cleanedData, type }) => {
  return (
    <OverlayTrigger
      trigger="click"
      rootClose
      placement={placement || "bottom"}
      overlay={
        <Popover>
          <Popover.Title as="h4" className="text-capitalize">
            Leave break down
          </Popover.Title>
          <Popover.Content as={"div"}>
            <Table size="md" className="mb-0">
              <thead className="text-capitalize">
                <tr>
                  <th className="text-nowrap">Leave name</th>
                  <th className="text-nowrap">Total days</th>
                </tr>
              </thead>
              <tbody className="text-capitalize">
                {cleanedData?.map((el) => (
                  <tr>
                    <td className="font-weight-bold text-nowrap">{el.name}</td>
                    <td>{el[type] || "..."}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </Popover.Content>
        </Popover>
      }
    >
      <Button
        className="d-inline p-0 border-0  px-2  rounded-circle  d-relative"
        size="sm"
        style={{ transform: `scale(0.7)` }}
      >
        <i className="fa fa-info"></i>
      </Button>
    </OverlayTrigger>
  );
};
